import React from "react";
import "./Button.scss";
const Button = ({ href, onClick, text ,btnColor }) => {
  return (
    <div>
      <a href={href} onClick={onclick} className={`btn ${btnColor} btn-animated`}>
        {text}
      </a>
    </div>
  );
};
export default Button;
